<template>
  <sk-layouts></sk-layouts>
</template>
<script>
export default {
  props: [],
  components: {},
  mixins: [],
  data() {
    return {}
  },
  mounted() {},
  created() {},
  watch: {},
  computed: {},
  filters: {},
  methods: {}
}
</script>
